import {
  interpolateCividis,
  interpolateInferno,
  interpolateMagma,
  interpolateTurbo,
  interpolateViridis,
  interpolateYlGnBu,
  interpolateYlGn,
  interpolateYlOrRd,
  schemeYlOrRd,
  schemeYlGn,
} from 'd3-scale-chromatic'

import { indexBy } from 'util/data'

export const riskColors = schemeYlOrRd[5]
export const interventionColors = schemeYlGn[5]

// use 10% stops for interpolated colors
const colorScale = [...Array(11).keys()].map((d) => d / 10)

export const colormaps = [
  {
    id: 'turbo',
    colors: colorScale.map(interpolateTurbo),
    interpolate: interpolateTurbo,
  },
  {
    id: 'viridis',
    colors: colorScale.map(interpolateViridis).reverse(),
    interpolate: interpolateViridis,
    reverse: true,
  },
  {
    id: 'cividis',
    colors: colorScale.map(interpolateCividis).reverse(),
    interpolate: interpolateCividis,
    reverse: true,
  },
  {
    id: 'yellow-blue',
    colors: colorScale.map(interpolateYlGnBu),
    interpolate: interpolateYlGnBu,
  },
  {
    id: 'yellow-green',
    colors: colorScale.map(interpolateYlGn),
    interpolate: interpolateYlGn,
  },
  {
    id: 'inferno',
    colors: colorScale.map(interpolateInferno).reverse(),
    interpolate: interpolateInferno,
    reverse: true,
  },
  {
    id: 'magma',
    colors: colorScale.map(interpolateMagma).reverse(),
    interpolate: interpolateMagma,
    reverse: true,
  },
  {
    id: 'yellow-red',
    colors: colorScale.map(interpolateYlOrRd),
    interpolate: interpolateYlOrRd,
  },
]
export const colormapIndex = indexBy(colormaps, 'id')

export const colormapGradient = (colormapId) => {
  const { colors } = colormapIndex[colormapId]
  const stops = colors
    .map((color, i) => `${color} ${(i / (colors.length - 1)) * 100}%`)
    .join(', ')
  return `linear-gradient(90deg, ${stops})`
}
